import { createTheme, ThemeOptions } from "@mui/material/styles";

const errorColor = "#D32F2F";
const movieceptionBrandColor = "#8B1E3F";
const movieceptionBrandColorMuted = "#B85A6E";
const mainGreen = "#2F8F6B";
const darkGreen = "#26785A";
const progressBlue = "#2563EB";
const progressBlueMuted = "#3B6FEF";

const sharedOptions: ThemeOptions = {
    typography: {
        fontFamily: "'Inter', -apple-system, sans-serif",
        h1: { fontWeight: 600 },
        h2: { fontWeight: 600 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 500 },
        h5: { fontWeight: 500 },
        h6: { fontWeight: 500 },
        button: { textTransform: "none", fontWeight: 500 },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: "10px 20px",
                },
            },
            variants: [
                {
                    props: { variant: "outlined", color: "error" },
                    style: {
                        color: errorColor,
                        borderColor: errorColor,
                        "&:hover": {
                            borderColor: errorColor,
                            backgroundColor: "rgba(110, 16, 39, 0.04)",
                        },
                    },
                },
            ],
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                },
            },
        },
        // A Menu auto-focuses its first item on open, and MUI highlights a
        // focused item like a hovered one, so the first row looks pre-selected.
        // Drop the highlight on plain :focus (mouse/auto-focus) but keep it for
        // :focus-visible (keyboard nav) and :hover.
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&:focus:not(:focus-visible):not(:hover)": {
                        backgroundColor: "transparent",
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    color: movieceptionBrandColor,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage:
                        "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.0) 100%)",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,

                    "&.Mui-focused fieldset": {
                        borderColor: movieceptionBrandColor,
                    },
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                // root: {
                //     height: 6,
                //     borderRadius: 999,
                //     overflow: "hidden",
                // },

                // colorPrimary: {
                //     backgroundColor: "rgba(37, 99, 235, 0.12)",
                // },

                // bar: {
                //     borderRadius: 999,
                //     backgroundColor: progressBlueMuted,
                // }
            },
        },
    },
    palette: {
        primary: {
            main: movieceptionBrandColor,
        },
        secondary: {
            main: "#6F5A5E",
        },
        green: {
            main: mainGreen,
            secondary: darkGreen,
        },
        blue: {
            main: progressBlue,
            secondary: progressBlueMuted,
        },
        warning: {
            main: "#D9A441",
        },
        error: {
            main: errorColor,
        },
        brand: {
            main: movieceptionBrandColor,
            secondary: movieceptionBrandColorMuted,
        },
        destructive: {
            main: "#6E1027",
        },
        action: {
            hover: "rgba(255,255,255,0.06)",
            selected: "rgba(255,255,255,0.08)",
        },
    },
};

export const lightTheme = createTheme({
    ...sharedOptions,
    palette: {
        ...(sharedOptions.palette as any),
        mode: "light",
        background: {
            default: "#FAFAFA",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#1A1A1A",
            secondary: "#6B6B6B",
        },
        divider: "#E5E5E5",
    },
});

export const darkTheme = createTheme({
    ...sharedOptions,
    palette: {
        ...(sharedOptions.palette as any),
        mode: "dark",
        background: {
            default: "#121417",
            paper: "#1E2126",
        },
        text: {
            primary: "#E6E6E6",
            secondary: "#9AA0A6",
        },
        divider: "rgba(255,255,255,0.08)",
    },
});